import { Field, Float, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class UpdateToCartArgs extends ActionArgs {
  @Field(() => String)
  orderId: string

  @Field(() => String)
  itemId: string

  @Field(() => Float)
  quantity: number
}
